import dynamic from "next/dynamic";
import { BlockRenderer } from ".";
import { Suspense } from "react";

//core blocks
const Cover = dynamic(() => import("@litonarefin/components/CoreBlocks/Cover"));
const Heading = dynamic(() => import("@litonarefin/components/CoreBlocks/Heading"));
const Paragraph = dynamic(() => import("@litonarefin/components/CoreBlocks/Paragraph"));
const Columns = dynamic(() => import("@litonarefin/components/CoreBlocks/Columns"));
const Column = dynamic(() => import("@litonarefin/components/CoreBlocks/Column"));
const Code = dynamic(() => import("@litonarefin/components/CoreBlocks/Code"));
const List = dynamic(() => import("@litonarefin/components/CoreBlocks/List"));
const ListItem = dynamic(() => import("@litonarefin/components/CoreBlocks/ListItem"));
const Html = dynamic(() => import("@litonarefin/components/CoreBlocks/Html"));
const Image = dynamic(() => import("@litonarefin/components/CoreBlocks/Image"));
const Buttons = dynamic(() => import("@litonarefin/components/CoreBlocks/Buttons"));
const Button = dynamic(() => import("@litonarefin/components/CoreBlocks/Button"));
const Video = dynamic(() => import("@litonarefin/components/CoreBlocks/Video"));
const Separator = dynamic(() => import("@litonarefin/components/CoreBlocks/Separator"));
const Youtube = dynamic(() => import("@litonarefin/components/CoreBlocks/Youtube"));
const Spacer = dynamic(() => import("@litonarefin/components/CoreBlocks/Spacer"));

export const coreBlocks = {
  ["core/columns"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Columns attributes={block?.attributes} colNumbers={block.innerBlocks?.length}>
        <BlockRenderer blocks={block.innerBlocks} />
      </Columns>
    </Suspense>
  ),
  ["core/column"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Column attributes={block?.attributes}>
        <BlockRenderer blocks={block.innerBlocks} />
      </Column>
    </Suspense>
  ),
  ["core/video"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Video attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/embed"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Youtube attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/buttons"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Buttons key={block.id} attributes={block?.attributes}>
        <BlockRenderer blocks={block.innerBlocks} />
      </Buttons>
    </Suspense>
  ),
  ["core/button"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Button attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/html"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Html attributes={block?.attributes} originalContent={block?.originalContent} />
    </Suspense>
  ),
  ["core/list-item"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <ListItem attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/list"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <List attributes={block?.attributes} originalContent={block?.originalContent}>
        <BlockRenderer blocks={block.innerBlocks} />
      </List>
    </Suspense>
  ),
  ["core/code"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Code key={block.id} attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/cover"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Cover image={block.attributes.url}>
        <BlockRenderer blocks={block.innerBlocks} />
      </Cover>
    </Suspense>
  ),
  ["core/heading"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Heading attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/paragraph"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Paragraph attributes={block?.attributes} />
    </Suspense>
  ),
  // ["core/group"]: (block) =>
  // ["core/block"]: (block) => {
  //     return <BlockRenderer  blocks={block.innerBlocks} />;
  // }
  ["core/image"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Image attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/separator"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Separator attributes={block?.attributes} />
    </Suspense>
  ),
  ["core/spacer"]: (block) => (
    <Suspense fallback="" key={block?.id}>
      <Spacer attributes={block?.attributes} />
    </Suspense>
  ),
};
